import { useState, useRef } from 'react';
import Badge from '../Badge';
import {
    Container, BadgeContainer, StyledChevron,
} from './styled';
import TagBadge from './badge';

interface TagsProps {
    value?: string[];
    maxBadges?: number;
    agentId: string;
    entity: 'customer' | 'call' | 'opportunity' | 'workspace';
    borderRadius?: 'square' | 'semi-rounded' | 'rounded' | 'semi-square';
}

const Tags = ({
    value = [],
    maxBadges = 3,
    borderRadius = 'semi-rounded',
    agentId,
    entity,
}: TagsProps) => {
    const [expanded, setExpanded] = useState(false);
    const triggerRef = useRef<HTMLDivElement>(null);
    const visibleTags = expanded ? value : value.slice(0, maxBadges);
    const remainingCount = value.length - maxBadges;
    const showMoreBadge = remainingCount > 0 && !expanded;
    const showLessBadge = expanded && remainingCount > 0;

    if (!value || value.length === 0) return null;

    return (
        <Container>
            {visibleTags.map((tag) => (
                <TagBadge key={tag} tag={tag} agentId={agentId} entity={entity} />
            ))}

            {showMoreBadge && (
                <BadgeContainer
                    key="tag-more"
                    onClick={() => setExpanded(true)}
                    ref={triggerRef}
                    clickable
                >
                    <Badge variant="outline-brand" borderRadius={borderRadius}>
                        <StyledChevron expanded={false} title="Show more tags" />
                        +
                        {remainingCount}
                        {' '}
                        more
                    </Badge>
                </BadgeContainer>
            )}

            {showLessBadge && (
                <BadgeContainer
                    key="tag-less"
                    onClick={() => setExpanded(false)}
                    clickable
                >
                    <Badge variant="outline-brand" borderRadius={borderRadius}>
                        <StyledChevron expanded title="Show fewer tags" />
                        Show less
                    </Badge>
                </BadgeContainer>
            )}
        </Container>
    );
};

export default Tags;
